/**
 * Groups together adjacent nodes of the same type.
 * For example: [<ol>, <ol>, <ul>, <ol>] => [[<ol, <ol>], [<ul>], [<ol>]]
 *
 * @param {Array} nodes The array of nodes to group
 *
 * @returns {Array} An array containing the grouped node lists
 */
export const groupNodesByType = (nodes) => {

	const result = [];

	let i = 0;

	while (i < nodes.length) {

		let node = nodes[i];
		const groupType = node.type;
		const group = [];

		while (node && node.type === groupType) {

			group.push(node);
			i += 1;
			node = nodes[i];

		}

		result.push(group);

	}

	return result;

};
